import React from "react";
import PropTypes from "prop-types";

const variantClasses = {
	default: "bg-slate-900 text-white shadow hover:bg-slate-800",
	secondary: "bg-slate-100 text-slate-900 shadow-sm hover:bg-slate-200",
	outline:
		"border border-slate-200 bg-white text-slate-900 shadow-sm hover:bg-slate-50",
	ghost: "text-slate-900 hover:bg-slate-100",
	destructive: "bg-rose-600 text-white shadow-sm hover:bg-rose-700",
	link: "text-slate-900 underline-offset-4 hover:underline",
};

const sizeClasses = {
	default: "h-10 px-4 py-2",
	sm: "h-9 px-3",
	lg: "h-11 px-5",
	icon: "h-10 w-10",
	"icon-sm": "h-8 w-8",
	"icon-lg": "h-12 w-12",
};

function cn(...classes) {
	return classes.filter(Boolean).join(" ");
}

/**
 * Ho creato questo Button per portarci il look&feel di shadcn/ui senza
 * dipendenze extra: supporta varianti, taglie (incluse icon-sm/icon-lg) e
 * gestisce automaticamente il type quando resta un vero <button>.
 */
const Button = React.forwardRef(function Button(
	{ variant = "default", size = "default", as = "button", className, type, children, ...props },
	ref
) {
	const Component = as || "button";
	const finalType = Component === "button" ? type || "button" : undefined;

	return (
		<Component
			ref={ref}
			type={finalType}
			className={cn(
				"inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
				variantClasses[variant] ?? variantClasses.default,
				sizeClasses[size] ?? sizeClasses.default,
				className
			)}
			{...props}
		>
			{children}
		</Component>
	);
});

Button.propTypes = {
	variant: PropTypes.oneOf([
		"default",
		"secondary",
		"outline",
		"ghost",
		"destructive",
		"link",
	]),
	size: PropTypes.oneOf(["default", "sm", "lg", "icon", "icon-sm", "icon-lg"]),
	as: PropTypes.elementType,
	className: PropTypes.string,
	type: PropTypes.string,
	children: PropTypes.node.isRequired,
};

export default Button;

